import { EventPageResolver } from "./EventPageResolver";
import { BasePageProviders } from "./PageProviders";

export const EventPageProviders = () => (
  <BasePageProviders>
    <EventPageResolver />
  </BasePageProviders>
);
